import React, { useEffect, useState } from "react";
import SolutionsCard from "./Cards/SolutionCard";
import NoData from "../NoData/NoData";
import "./css/all.solution.cards.css";

const AllSolutionCards = ({ searchResults, solutions }) => {

  const cardsData =
    searchResults && searchResults.length >= 0 ? searchResults : solutions;

  return (
    <>
      <div id="sol-dashboard">
        <div className="marketPlaceCardsContainer row d-flex">
          {cardsData.map((card, idx) => (
            <div
              className="col-12 col-md-4 col-lg-4 col-xl-3"
              key={`card_${card.id}_${idx}`}
              style={{ padding: "12px" }}
            >
              <SolutionsCard solution={card} />
            </div>
          ))}
        </div>
        {cardsData.length === 0 && (
          <NoData
            containerClsNames={"sol-dashbrd-nodata-cls"}
            main={"Registered Solutions"}
          />
        )}
      </div>
    </>
  );
};

export default AllSolutionCards;
